
export default function IntroItem({ intro }) {
    return (
        <article className="main-intro">
            <p>{intro.content1}</p>
        </article>
    );
}
